import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <section className="bg-cream py-14 sm:py-20" data-testid="privacy-hero">
        <div className="container-site max-w-3xl">
          <Reveal>
            <p className="label-eyebrow mb-5">Poolside Cooking</p>
            <h1 className="font-display font-black tracking-tight leading-[1.02] text-3xl sm:text-4xl lg:text-5xl text-ink">
              Privacy <span className="text-pool">Policy.</span>
            </h1>
          </Reveal>
        </div>
      </section>
      <section className="bg-white py-12 sm:py-16">
        <div className="container-site max-w-3xl space-y-8 text-slate-600 text-sm sm:text-base leading-relaxed">
          <div>
            <h2 className="font-display font-bold text-lg text-ink mb-2">What we collect</h2>
            <p>
              When you join the Stay Poolside list, we collect your email address, the date you signed up, and the
              page you signed up from. That&rsquo;s it.
            </p>
          </div>
          <div>
            <h2 className="font-display font-bold text-lg text-ink mb-2">How we use it</h2>
            <p>
              We use your email to send Poolside Cooking updates — celebrity guest announcements, new episodes,
              brunches, live events, and ticket drops. We never sell or share your information with third parties
              for their own marketing.
            </p>
          </div>
          <div>
            <h2 className="font-display font-bold text-lg text-ink mb-2">Unsubscribe anytime</h2>
            <p>
              Every email includes a way to opt out, and you can unsubscribe at any time by contacting us through
              our <Link to="/contact" className="text-pool font-semibold hover:underline" data-testid="privacy-contact-link">contact page</Link>.
              Once you unsubscribe, your status is respected and you won&rsquo;t be re-added to marketing emails.
            </p>
          </div>
          <p className="text-xs text-slate-400">Last updated: October 2026</p>
        </div>
      </section>
    </div>
  );
}
